var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',[_c('v-container',{staticClass:"page-not-found",attrs:{"fluid":""}},[_c('h1',[_vm._v("Page Not Found")]),_c('p',[_vm._v("Use button in top left corner to navigate to the correct page")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }